// extracted by mini-css-extract-plugin
module.exports = {"card-media":"CachedCardMedia_card-media__13RIu"};